/*
  moné product page fold (pilot: Forest).
  1. Kaching's "Choose product" list and the pair card name each racket by product title
     ("Cocoa - Padel Racket"). This shows the page's colour circle and the colour name instead.
  2. The sticky add-to-cart bar follows Kaching: when the pair is selected it shows the same price
     as Kaching's pair card, and its button presses the page's main Add to cart (which Kaching
     handles), so the bar adds exactly what it shows. With one racket selected it is untouched.
  3. The sticky bar stays down until the main Add to cart button has scrolled up past the header
     (the theme also shows it while the button is still below the first screen).
  Only data attributes, a CSS variable and one extra price element are set (pdp-fold.css draws
  them), so neither app's own markup or text is changed, and their updates keep working. Inert
  without the page marker.
*/
(function () {
  'use strict';
  if (!document.querySelector('.pdp-fold-on')) return;

  var SEPARATOR = ' - ';

  // Colour circle per colour name, from moné's circles (snippets/mone-colour-swatches.liquid): a flat colour or the
  // product photo.
  function swatchImages() {
    var images = {};
    document.querySelectorAll('[data-mone-swatches] [data-swatch-name]').forEach(function (item) {
      var name = item.getAttribute('data-swatch-name').toLowerCase();
      var colour = item.getAttribute('data-swatch-colour');
      var photo = item.getAttribute('data-swatch-image');
      if (colour) images[name] = 'linear-gradient(' + colour + ', ' + colour + ')';
      else if (photo) images[name] = 'url("' + photo + '")';
    });
    return images;
  }

  // Kaching marks its chosen option with --selected; the first option is one racket, any other is the pair
  function selectedPair() {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    for (var i = 1; i < bars.length; i++) {
      if (bars[i].classList.contains('kaching-bundles__bar--selected')) return bars[i];
    }
    return null;
  }

  function syncStickyBar() {
    var bar = document.querySelector('.sticky-atc-bar');
    var info = bar && bar.querySelector('.sticky-atc-bar__product-info');
    var original = info && info.querySelector('.f-price:not(.pdp-sticky-price)');
    if (!original) return;

    var pair = selectedPair();
    var kachingPrice = pair && pair.querySelector('.kaching-bundles__bar-price');
    var text = kachingPrice ? kachingPrice.textContent.trim() : '';

    var mirror = info.querySelector('.pdp-sticky-price');
    if (!text) {
      if (bar.hasAttribute('data-pdp-pair')) bar.removeAttribute('data-pdp-pair');
      return;
    }
    if (!mirror) {
      mirror = document.createElement('div');
      mirror.className = 'f-price pdp-sticky-price';
      mirror.innerHTML = '<div class="f-price__regular"><span class="f-price-item f-price-item--regular"></span></div>';
      original.insertAdjacentElement('afterend', mirror);
    }
    var target = mirror.querySelector('.f-price-item');
    if (target.textContent !== text) target.textContent = text;
    if (!bar.hasAttribute('data-pdp-pair')) bar.setAttribute('data-pdp-pair', '');
  }

  // With the pair selected, the bar's own form would add one racket: press the main button instead
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.sticky-atc-bar .f-product-form__submit');
    var bar = button && button.closest('.sticky-atc-bar');
    if (!bar || !bar.hasAttribute('data-pdp-pair')) return;
    var main = document.querySelector('.f-main-product-form .f-product-form__submit');
    if (!main || main.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    main.click();
  }, true);

  // Hold the sticky bar down until the inline Add to cart has been scrolled past (its bottom is above the header).
  // Fails open: with no bar or no button the theme's own behaviour applies.
  function updateStickyHold() {
    var bar = document.querySelector('.sticky-atc-bar');
    var button = document.querySelector('.f-main-product-form .f-product-form__submit');
    if (!bar) return;
    var headerHeight = (window.FoxThemeSettings && window.FoxThemeSettings.headerHeight) || 80;
    var hold = !!button && button.getBoundingClientRect().bottom > headerHeight;
    if (hold !== bar.hasAttribute('data-pdp-hold')) bar.toggleAttribute('data-pdp-hold', hold);
  }

  // Measured at the start of the next frame, never straight after this script has changed the page: reading the button's
  // position after a DOM write forces the browser to lay the page out again on the spot (a "forced reflow"), which the
  // apps' rendering made happen on every frame while the page loaded. The theme only shows the bar from an
  // IntersectionObserver callback, which runs after that frame, so the hold is always in place first.
  var holdQueued = false;
  function queueHold() {
    if (holdQueued) return;
    holdQueued = true;
    requestAnimationFrame(function () {
      holdQueued = false;
      updateStickyHold();
    });
  }
  window.addEventListener('scroll', queueHold, { passive: true });
  window.addEventListener('resize', queueHold);
  queueHold();

  // Runs straight from the mutation callback (before the browser paints), so a racket row Kaching has just
  // rendered never shows its long "Forest - Padel Racket" title.
  function nameRackets() {
    var images = swatchImages();
    document.querySelectorAll('.kaching-bundles__choose-product__product-title, .kaching-bundles__collection-product__title').forEach(function (title) {
      var name = title.textContent.trim().split(SEPARATOR)[0];
      if (!name) return;
      // the short name goes on at once, so "Forest - Padel Racket" never shows; the circle follows when matched
      if (title.getAttribute('data-pdp-name') !== name) title.setAttribute('data-pdp-name', name);
      // swatches are named by colour ("Himalaya"); a Hybrid's title starts "Himalaya Hybrid", so fall back to the first word
      var key = name.toLowerCase();
      var image = images[key] || images[key.split(' ')[0]];
      if (image && !title.hasAttribute('data-pdp-swatched')) {
        title.style.setProperty('--pdp-swatch', image);
        title.setAttribute('data-pdp-swatched', '');
      }
    });
  }

  function decorate() {
    nameRackets();

    // Kaching's single option says "You save 0₫": mark it so pdp-fold.css can hide that line
    document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
      var subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      // zero when every digit in the line is 0, whatever the currency ("0₫", "RM0 MYR", "$0.00")
      var digits = subtitle ? subtitle.textContent.replace(/\D/g, '') : '';
      var zero = digits !== '' && /^0+$/.test(digits);
      if (zero !== bar.hasAttribute('data-pdp-no-saving')) bar.toggleAttribute('data-pdp-no-saving', zero);
    });

    syncStickyBar();
    queueHold();
  }

  // Both apps render after load and re-render on interaction: re-apply once per frame on DOM changes.
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      decorate();
    });
  }
  new MutationObserver(function () {
    nameRackets();
    schedule();
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class']
  });
  schedule();
})();
